import { DailyAgendaActionFactory, DailyAgendaActions } from '../actions';

export const createOnFiltersChangeAction: DailyAgendaActionFactory<
  DailyAgendaActions['onFiltersChange']
> =
  ({ setState, getState, flowAPI }) =>
  async (filters) => {
    console.log(filters);
  };
